export default "__VITE_ASSET__DkItvYz___"